import { Component, ChangeDetectionStrategy } from '@angular/core';
import { LoginLayoutComponent } from '../../components/login-layout/login-layout.component';
import { ResendEmailNotificationComponent } from '../../components/resend-email-notification/resend-email-notification.component';

@Component({
  selector: 'app-resend-email',
  imports: [LoginLayoutComponent, ResendEmailNotificationComponent],
  templateUrl: './resend-email.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './resend-email.component.scss',
})
export class ResendEmailComponent {}
